import React from 'react';

const ProFindLogo = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 200 50"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    data-testid="proFindLogo"
    style={{
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      strokeLinejoin: 'round',
      strokeMiterlimit: 2,
    }}
  >
    <g id="Artboard1" transform="matrix(0.8,0,0,1,0,0)">
      <rect x="0" y="0" width="250" height="50" style={{ fill: 'none' }} />
      <g
        id="Layer_1"
        transform="matrix(0.612455,0,0,0.489964,-6.89839,7.44298)"
      >
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M148.73,37.13L70.9,121.7L148.73,121.7L148.73,37.13Z"
            style={{
              fill: 'rgb(247,191,173)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M148.73,122.33L70.9,122.33C70.651,122.329 70.426,122.179 70.33,121.95C70.228,121.725 70.271,121.46 70.44,121.28L148.27,36.71C148.446,36.523 148.719,36.46 148.96,36.55C149.2,36.641 149.36,36.873 149.36,37.13L149.36,121.7C149.36,122.046 149.076,122.33 148.73,122.33ZM72.32,121.08L148.11,121.08L148.11,38.73L72.32,121.08Z"
            style={{
              fill: 'rgb(247,191,173)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M148.73,340.67L41.19,453.51L40.8,310.69L148.73,195.15L148.73,340.67Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M41.19,454.13C41.114,454.144 41.036,454.144 40.96,454.13C40.722,454.038 40.565,453.805 40.57,453.55L40.17,310.73C40.168,310.57 40.229,310.415 40.34,310.3L148.28,194.72C148.451,194.531 148.725,194.47 148.96,194.57C149.2,194.661 149.36,194.893 149.36,195.15L149.36,340.67C149.363,340.832 149.297,340.988 149.18,341.1L41.64,453.94C41.524,454.064 41.36,454.133 41.19,454.13ZM41.42,310.93L41.81,451.93L148.11,340.4L148.11,196.73L41.42,310.93Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M343.79,37.13L148.73,37.13L148.73,121.7L264.77,121.7L343.79,37.13Z"
            style={{
              fill: 'rgb(255,96,27)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M264.77,122.33L148.77,122.33C148.428,122.325 148.15,122.042 148.15,121.7L148.15,37.13C148.15,36.79 148.43,36.51 148.77,36.51L343.79,36.51C344.037,36.506 344.263,36.653 344.36,36.88C344.461,37.108 344.418,37.376 344.25,37.56L265.25,122.13C265.124,122.259 264.95,122.331 264.77,122.33ZM149.36,121.08L264.5,121.08L342.35,37.76L149.35,37.76L149.36,121.08Z"
            style={{
              fill: 'rgb(255,96,27)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M455.41,195.14L308.82,341.63L308.82,195.78L455.41,37.13L455.41,195.14Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M308.82,342.25C308.741,342.264 308.659,342.264 308.58,342.25C308.347,342.151 308.194,341.923 308.19,341.67L308.19,195.78C308.19,195.62 308.251,195.467 308.36,195.35L455,36.71C455.117,36.58 455.285,36.506 455.46,36.506C455.8,36.506 456.08,36.786 456.08,37.126C456.08,37.127 456.08,37.129 456.08,37.13L456.08,195.13C456.084,195.295 456.019,195.455 455.9,195.57L309.26,342.07C309.143,342.186 308.985,342.251 308.82,342.25ZM309.44,196L309.44,340.1L454.78,194.88L454.78,38.73L309.44,196Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M308.82,341.63L148.73,340.67L148.73,195.15L308.82,195.78L308.82,341.63Z"
            style={{
              fill: 'rgb(14,25,160)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M308.82,342.25L148.73,341.3C148.388,341.295 148.11,341.012 148.11,340.67L148.11,195.15C148.108,194.982 148.172,194.82 148.29,194.7C148.407,194.578 148.571,194.513 148.74,194.52L308.82,195.15C308.82,195.15 308.82,195.15 308.82,195.15C309.16,195.15 309.44,195.43 309.44,195.77C309.44,195.773 309.44,195.777 309.44,195.78L309.44,341.63C309.44,341.633 309.44,341.637 309.44,341.64C309.44,341.975 309.165,342.25 308.83,342.25C308.827,342.25 308.823,342.25 308.82,342.25ZM149.36,340.05L308.19,341L308.19,196.4L149.36,195.77L149.36,340.05Z"
            style={{
              fill: 'rgb(14,25,160)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M1605.41,111.68L1648.62,111.68L1782.38,315L1783.07,315L1783.07,111.68L1816,111.68L1816,347.76L1774.16,347.76L1639,155.69L1638.32,155.69L1638.32,347.76L1605.39,347.76L1605.41,111.68Z"
            style={{
              fill: 'rgb(255,96,27)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M546.3,111.68L631.69,111.68C647.237,111.68 660.04,113.837 670.1,118.15C680.16,122.463 688.107,127.93 693.94,134.55C699.655,140.974 703.823,148.624 706.12,156.91C710.693,172.534 710.693,189.146 706.12,204.77C703.823,213.056 699.655,220.706 693.94,227.13C688.113,233.71 680.167,239.187 670.1,243.56C660.033,247.933 647.23,250.08 631.69,250L579.22,250L579.22,347.75L546.3,347.75L546.3,111.68ZM579.22,220.68L622.43,220.68C628.796,220.677 635.15,220.152 641.43,219.11C647.333,218.198 653.027,216.247 658.25,213.35C663.213,210.507 667.302,206.355 670.07,201.35C673.043,196.117 674.533,189.303 674.54,180.91C674.547,172.517 673.057,165.71 670.07,160.49C667.305,155.482 663.215,151.33 658.25,148.49C653.028,145.589 647.333,143.636 641.43,142.72C635.15,141.678 628.796,141.153 622.43,141.15L579.22,141.15L579.22,220.68Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M763.4,111.68L848.8,111.68C864.34,111.68 877.143,113.837 887.21,118.15C897.277,122.463 905.223,127.93 911.05,134.55C916.765,140.974 920.933,148.624 923.23,156.91C925.446,164.692 926.597,172.739 926.65,180.83C926.689,196.551 921.023,211.764 910.71,223.63C905.365,229.715 898.974,234.796 891.84,238.63C884.16,242.809 875.707,245.375 867,246.17L935.94,347.76L894.76,347.76L833,250L796.3,250L796.3,347.75L763.4,347.75L763.4,111.68ZM796.33,220.68L839.54,220.68C845.906,220.677 852.26,220.152 858.54,219.11C864.443,218.198 870.137,216.247 875.36,213.35C880.323,210.507 884.412,206.355 887.18,201.35C890.147,196.117 891.637,189.303 891.65,180.91C891.663,172.517 890.173,165.71 887.18,160.49C884.415,155.482 880.325,151.33 875.36,148.49C870.138,145.589 864.443,143.636 858.54,142.72C852.26,141.678 845.906,141.153 839.54,141.15L796.33,141.15L796.33,220.68Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M1098.16,347.76C1079.63,347.76 1062.59,344.67 1047.04,338.49C1032.15,332.721 1018.56,324.023 1007.09,312.91C995.921,301.958 987.05,288.885 981,274.46C968.418,243.792 968.418,209.368 981,178.7C987.044,164.279 995.904,151.207 1007.06,140.25C1018.53,129.138 1032.11,120.443 1047,114.68C1062.56,108.487 1079.6,105.39 1098.12,105.39C1116.64,105.39 1133.67,108.487 1149.22,114.68C1164.13,120.444 1177.73,129.139 1189.22,140.25C1200.35,151.214 1209.19,164.285 1215.22,178.7C1227.8,209.368 1227.8,243.792 1215.22,274.46C1209.19,288.876 1200.35,301.948 1189.22,312.91C1177.73,324.021 1164.13,332.719 1149.22,338.49C1133.69,344.683 1116.67,347.773 1098.16,347.76ZM1098.16,318.45C1112.09,318.45 1124.66,316.003 1135.88,311.11C1146.68,306.499 1156.47,299.805 1164.69,291.41C1172.77,283.041 1179.07,273.121 1183.21,262.25C1191.9,239.271 1191.9,213.889 1183.21,190.91C1179.07,180.039 1172.77,170.119 1164.69,161.75C1156.48,153.341 1146.68,146.63 1135.88,142C1124.67,137.113 1112.09,134.67 1098.16,134.67C1084.23,134.67 1071.65,137.113 1060.42,142C1049.62,146.616 1039.83,153.313 1031.61,161.71C1023.53,170.079 1017.23,179.999 1013.09,190.87C1004.4,213.849 1004.4,239.231 1013.09,262.21C1017.23,273.081 1023.53,283.001 1031.61,291.37C1039.83,299.767 1049.62,306.461 1060.42,311.07C1071.63,315.997 1084.21,318.457 1098.16,318.45Z"
            style={{
              fill: 'rgb(0,10,227)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M1285.76,111.68L1438.38,111.68L1438.38,143.12L1318.68,143.12L1318.68,220.65L1430.15,220.65L1430.15,252.11L1318.68,252.11L1318.68,347.76L1285.76,347.76L1285.76,111.68Z"
            style={{
              fill: 'rgb(255,96,27)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M1496.34,110.09L1531.49,110.09L1529.27,347.76L1496.34,347.76L1496.34,110.09Z"
            style={{
              fill: 'rgb(255,96,27)',
              fillRule: 'nonzero',
            }}
          />
        </g>
        <g transform="matrix(0.191084,0,0,0.191084,10.9829,-6.96222)">
          <path
            d="M1886.65,111.26L1971.37,111.26C1988.52,111.26 2003.56,113.103 2016.47,116.79C2028.35,120.029 2039.68,125.028 2050.08,131.62C2059.09,137.395 2067.09,144.619 2073.75,153C2079.77,160.582 2084.78,168.907 2088.67,177.77C2092.23,185.922 2094.88,194.444 2096.57,203.18C2098.09,210.91 2098.89,218.763 2098.96,226.64C2098.97,241.343 2096.06,255.903 2090.39,269.47C2084.59,283.362 2075.94,295.885 2065,306.23C2053.81,316.99 2039.92,325.623 2023.33,332.13C2006.74,338.637 1987.59,341.893 1965.88,341.9L1886.65,341.9L1886.65,111.26ZM1919.58,312.6L1961.08,312.6C1974.47,312.669 1987.81,310.855 2000.69,307.21C2012.52,303.936 2023.64,298.468 2033.45,291.09C2042.82,283.932 2050.44,274.745 2055.75,264.22C2061.22,253.467 2063.96,240.923 2063.97,226.59C2063.97,219.197 2062.71,210.557 2060.2,200.67C2057.49,190.39 2052.65,180.792 2046,172.5C2039.01,163.6 2029.35,156.053 2017,149.86C2004.65,143.667 1988.65,140.573 1969,140.58L1919.61,140.58L1919.58,312.6Z"
            style={{
              fill: 'rgb(255,96,27)',
              fillRule: 'nonzero',
            }}
          />
        </g>
      </g>
    </g>
  </svg>
);

export default ProFindLogo;
